const hotel = {
  availableMealPlans: "แผนการรับประทานอาหารที่มีอยู่", // translated
  availableRoomsTypes: "ประเภทห้องพักที่ว่าง", // translated
  cancellationPolicy: "นโยบายการยกเลิก", // translated
  cancellationRules: "กฎการยกเลิก", // translated
  freeCancellationAvailable: "สามารถยกเลิกได้ฟรี", // translated
  nonRefundable: "ไม่สามารถขอคืนเงินได้", // translated
  priceFor: "ราคาสำหรับ", // translated
  nights: "คืน", // translated
  totalPrice: "ราคารวม", // translated
  seeAvailability: "ดูห้องว่าง", // translated
  myProfile: "ประวัติของฉัน", // translated
  travelTrust: "ความน่าเชื่อถือด้านการท่องเที่ยว", // translated
  signIn: "เข้าสู่ระบบ", // translated
  searchNow: "ค้นหาตอนนี้", // translated
  policy: "นโยบาย", // translated
  cxlRules: "กฎของ CXL", // translated
  room: "ห้อง", // translated
  cxlPolicy: "นโยบาย CXL", // translated
  beddingType: "ประเภทเครื่องนอน", // translated
  hotelName: "ชื่อโรงแรม", // translated
  reservationDate: "วันที่จอง", // translated
  maxPax: "แม็กซ์ แพกซ์", // translated
};


export default hotel;
